@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-sms-template-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [smsTemplate]="_context.formContext.item"
                (smsTemplateUpdated)="onSmsTemplateUpdated($event)"
                (canceled)="onCanceled($event)"></app-sms-template-form>
        </mat-tab>
    </mat-tab-group>
}
